import { Box, Hidden } from "@material-ui/core";
import { graphql } from "gatsby";
import React from "react";
import LocalizedLink from "../../components/localized-link";
import { formatPrice } from "../../helpers/price";
import { useExpressDeliveryAvailabilitySelector } from "../../hooks/use-express-delivery-availability";
import useFeatureFlag from "../../hooks/use-feature-flag";
import useLocalizedLocationPath from "../../hooks/use-localized-location-path";
import useTranslate from "../../hooks/use-translate";
import { CustomButton, MainTypography, Wrapper } from "./styles";

function FreeDeliveryBanner({}: Queries.FreeDeliveryBannerSectionFragmentFragment) {
  const isXpressEnabled = useFeatureFlag("SHOP_XPRESS");
  const t = useTranslate();

  const minimumTotal = useExpressDeliveryAvailabilitySelector(
    c => c.availableProvider?.deliveryTotalMinimum
  );

  const text = `<strong>FREE XPRESS delivery</strong> with orders above ${formatPrice(
    {
      amount: minimumTotal || 50
    },
    {
      hideZeros: true
    }
  )}`;

  if (!isXpressEnabled) {
    return null;
  }

  return (
    <Wrapper>
      <Box
        marginLeft={{ xs: 10, sm: 14, md: 16 }}
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        width="100%"
        maxWidth="calc(100% - 80px)"
      >
        <MainTypography dangerouslySetInnerHTML={{ __html: text }} />

        <Hidden implementation="css" smDown>
          <LocalizedLink to="/shop/products">
            <CustomButton variant="contained" size="small">
              {t("shop.browseAllProducts")}
            </CustomButton>
          </LocalizedLink>
        </Hidden>
      </Box>
    </Wrapper>
  );
}

export const FreeShippinhSectionFragment = graphql`
  fragment FreeDeliveryBannerSectionFragment on DatoCmsCModuleShopFreeDeliverySection {
    visibilitySettings {
      ...ContentModuleVisibilitySettingFragment
    }
    model {
      apiKey
    }
  }
`;

export default React.memo(FreeDeliveryBanner);
